import React from 'react';
import { Text } from '@rneui/themed';
import { View, Search as BaseSearch, } from '@annunciate/ui/dist/components';
export const Search = ({ initialQuery, onQueryUpdate, }) => {
    return (React.createElement(View, { style: { flexGrow: 1 } },
        React.createElement(BaseSearch, { initialQuery: initialQuery || undefined, onQueryUpdated: onQueryUpdate, EmptySearchComponent: React.createElement("div", { style: { display: 'flex', justifyContent: 'center', marginTop: 50 } },
                React.createElement(Text, null, "Enter a search query above.")) })));
};
//# sourceMappingURL=Search.js.map